"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = exports.zeroPad = exports.getInputIndex = exports.wait = exports.generateAdSetPrefix = exports.getMatches = exports.logError = exports.generateAdName = exports.generateName = exports.getPartialKeyByTitle = exports.getInputPartial = exports.getPartialKey = exports.getInputsByPlatform = exports.plural = void 0;
const titan_ads_1 = require("./ontologies/titan-ads");
const types_1 = require("./types");
const models_1 = require("lincd/lib/models");
const plural = (n) => (n === 1 ? '' : 's');
exports.plural = plural;
// FREE INDEXES: 41 and up
function getInputsByPlatform(platform) {
    switch (platform) {
        case 'quora': {
            // defaults
            const column = 'ad';
            const priority = 2;
            // Column doesn't matter if hidden
            return [
                /**
                 *
                 * Hidden inputs
                 *
                 */
                {
                    title: 'Ad ID',
                    column,
                    columnIndexInGoogleSheets: 1,
                    priority,
                    hidden: true,
                    required: false,
                },
                {
                    title: 'Ad Name',
                    column,
                    columnIndexInGoogleSheets: 2,
                    priority,
                    required: false,
                    hidden: true,
                },
                {
                    title: 'Status',
                    columnIndexInGoogleSheets: 3,
                    required: false,
                    priority,
                    column,
                    hidden: true,
                    shapePath: titan_ads_1.titanAds.statusGuidance,
                },
                /**
                 *
                 *
                 * Campaign inputs
                 *
                 *
                 */
                {
                    title: 'Campaign',
                    columnIndexInGoogleSheets: 4,
                    priority: 0,
                    hidden: true,
                    column: 'campaign',
                    options: [],
                    required: false,
                },
                {
                    title: 'Daily Budget ($US)',
                    columnIndexInGoogleSheets: 6,
                    priority: 1,
                    column: 'campaign',
                    required: true,
                    shapePath: titan_ads_1.titanAds.dailyBudget,
                    type: 'number',
                },
                {
                    title: 'Lifetime Budget ($US)',
                    columnIndexInGoogleSheets: 7,
                    priority: 1,
                    column: 'campaign',
                    required: false,
                    shapePath: titan_ads_1.titanAds.lifetimeBudget,
                    type: 'number',
                },
                {
                    title: 'Conversion Objective',
                    columnIndexInGoogleSheets: 8,
                    options: types_1.QUORA_OPT_CONVERSION_OBJECTIVE,
                    priority: 1,
                    column: 'campaign',
                    shapePath: titan_ads_1.titanAds.conversionObjective,
                    required: true,
                },
                {
                    title: 'Conversion Event',
                    columnIndexInGoogleSheets: 26,
                    options: types_1.QUORA_OPT_CONVERSION_EVENT,
                    priority: 1,
                    column: 'campaign',
                    shapePath: titan_ads_1.titanAds.conversionEvent,
                    required: false,
                },
                /**
                 *
                 *
                 * Ad Set inputs
                 *
                 *
                 */
                {
                    title: 'AdSet',
                    columnIndexInGoogleSheets: 5,
                    priority: 1,
                    hidden: true,
                    column: 'adset',
                    options: [],
                    required: false,
                },
                {
                    title: 'Placement',
                    columnIndexInGoogleSheets: 9,
                    options: types_1.QUORA_OPT_PLACEMENT,
                    priority: 1,
                    column: 'adset',
                    shapePath: titan_ads_1.titanAds.placement,
                    required: true,
                    usedInAdSetCreation: true,
                },
                {
                    title: 'Device & Browser',
                    columnIndexInGoogleSheets: 10,
                    options: types_1.QUORA_OPT_DEVICE_AND_BROWSER,
                    priority: 1,
                    shapePath: titan_ads_1.titanAds.deviceAndBrowser,
                    column: 'adset',
                    required: true,
                    usedInAdSetCreation: true,
                },
                {
                    title: 'Targeting Type',
                    columnIndexInGoogleSheets: 11,
                    options: types_1.QUORA_OPT_TARGETING_TYPE,
                    priority,
                    column: 'adset',
                    shapePath: titan_ads_1.titanAds.targetingType,
                    isDuplicateKey: true,
                    required: true,
                },
                {
                    title: 'Targeting Description',
                    columnIndexInGoogleSheets: 28,
                    priority,
                    column: 'adset',
                    shapePath: titan_ads_1.titanAds.targetingDescription,
                    isDuplicateKey: true,
                    required: false,
                },
                {
                    title: 'Targeting Theme',
                    columnIndexInGoogleSheets: 40,
                    priority,
                    column: 'adset',
                    shapePath: titan_ads_1.titanAds.targetingTheme,
                    isDuplicateKey: true,
                    required: false,
                },
                {
                    title: 'Included Locations',
                    columnIndexInGoogleSheets: 12,
                    priority,
                    shapePath: titan_ads_1.titanAds.includedLocations,
                    required: false,
                    column: 'adset',
                },
                {
                    title: 'Excluded Locations',
                    columnIndexInGoogleSheets: 13,
                    priority,
                    shapePath: titan_ads_1.titanAds.excludedLocations,
                    required: false,
                    column: 'adset',
                },
                {
                    title: 'Male',
                    columnIndexInGoogleSheets: 14,
                    required: false,
                    shapePath: titan_ads_1.titanAds.targetsMales,
                    priority,
                    checked: true,
                    column: 'adset',
                },
                {
                    title: 'Female',
                    columnIndexInGoogleSheets: 15,
                    required: false,
                    shapePath: titan_ads_1.titanAds.targetsFemales,
                    priority,
                    checked: true,
                    column: 'adset',
                },
                {
                    title: 'Unknown',
                    columnIndexInGoogleSheets: 16,
                    required: false,
                    shapePath: titan_ads_1.titanAds.targetsUnknown,
                    priority,
                    checked: true,
                    column: 'adset',
                },
                {
                    title: 'Bid Amount ($US)',
                    columnIndexInGoogleSheets: 17,
                    priority,
                    shapePath: titan_ads_1.titanAds.bidAmount,
                    column: 'adset',
                    required: true,
                    type: 'number',
                },
                {
                    title: 'Ad Delivery',
                    columnIndexInGoogleSheets: 18,
                    required: true,
                    shapePath: titan_ads_1.titanAds.adDelivery,
                    priority,
                    column: 'adset',
                    options: types_1.QUORA_OPT_AD_DELIVERY,
                },
                /**
                 *
                 *
                 * Ad inputs
                 *
                 *
                 */
                {
                    title: 'Creative Type',
                    columnIndexInGoogleSheets: 43,
                    priority,
                    column,
                    shapePath: titan_ads_1.titanAds.creativeType,
                    required: true,
                    options: types_1.QUORA_OPT_CREATIVE_TYPE,
                },
                {
                    title: 'Headline',
                    columnIndexInGoogleSheets: 20,
                    priority,
                    column,
                    maxlength: 65,
                    shapePath: titan_ads_1.titanAds.headline,
                    required: true,
                },
                {
                    title: 'Headline Description',
                    columnIndexInGoogleSheets: 41,
                    required: false,
                    priority,
                    column,
                    hidden: false,
                    shapePath: titan_ads_1.titanAds.headlineDescription,
                },
                {
                    title: 'Sub Headline',
                    columnIndexInGoogleSheets: 19,
                    priority,
                    column,
                    forbidDash: true,
                    isDuplicateKey: true,
                    shapePath: titan_ads_1.titanAds.bodyText,
                    maxlength: 105,
                    required: true,
                },
                {
                    title: 'Sub Headline Description',
                    columnIndexInGoogleSheets: 42,
                    required: false,
                    priority,
                    column,
                    hidden: false,
                    shapePath: titan_ads_1.titanAds.subHeadlineDescription,
                },
                {
                    title: 'Creative Asset URL',
                    columnIndexInGoogleSheets: 25,
                    priority,
                    column,
                    required: true,
                    shapePath: titan_ads_1.titanAds.assetFile,
                    type: 'url',
                },
                {
                    title: 'CTA',
                    columnIndexInGoogleSheets: 21,
                    priority,
                    column,
                    shapePath: titan_ads_1.titanAds.cta,
                    isDuplicateKey: true,
                    options: types_1.QUORA_OPT_CTA,
                    required: true,
                },
                {
                    title: 'Tracker URLs',
                    column,
                    columnIndexInGoogleSheets: 39,
                    priority,
                    required: false,
                    shapePath: titan_ads_1.titanAds.trackers,
                },
                {
                    title: 'Date Launched',
                    columnIndexInGoogleSheets: 24,
                    priority,
                    column,
                    shapePath: titan_ads_1.titanAds.launchDate,
                    date: new Date(),
                    required: true,
                },
                {
                    title: 'Business Name',
                    columnIndexInGoogleSheets: 33,
                    priority,
                    column,
                    shapePath: titan_ads_1.titanAds.businessName,
                    required: true,
                },
                /**
                 * INTERNAL REPORTING
                 */
                {
                    title: 'Campaign Geo',
                    column: 'campaign',
                    columnIndexInGoogleSheets: 29,
                    priority: 0,
                    shapePath: titan_ads_1.titanAds.geo,
                    required: false,
                    internal: true,
                },
                {
                    title: 'Campaign Offer',
                    column: 'campaign',
                    columnIndexInGoogleSheets: 30,
                    priority: 0,
                    shapePath: titan_ads_1.titanAds.offer,
                    required: false,
                    internal: true,
                },
                {
                    title: 'Vertical',
                    column: 'campaign',
                    columnIndexInGoogleSheets: 34,
                    priority: 0,
                    shapePath: titan_ads_1.titanAds.vertical,
                    required: false,
                    internal: true,
                },
                {
                    title: 'AdSet Geo',
                    column: 'adset',
                    columnIndexInGoogleSheets: 37,
                    priority: 0,
                    shapePath: titan_ads_1.titanAds.geo,
                    required: false,
                    internal: true,
                },
                {
                    title: 'AdSet Offer',
                    column: 'adset',
                    columnIndexInGoogleSheets: 38,
                    priority: 0,
                    shapePath: titan_ads_1.titanAds.offer,
                    required: false,
                    internal: true,
                },
                {
                    title: 'Network',
                    column: 'ad',
                    columnIndexInGoogleSheets: 31,
                    priority: 0,
                    shapePath: titan_ads_1.titanAds.network,
                    required: false,
                    internal: true,
                },
                {
                    title: 'Advertiser',
                    column: 'ad',
                    columnIndexInGoogleSheets: 32,
                    priority: 0,
                    shapePath: titan_ads_1.titanAds.advertiser,
                    required: false,
                    internal: true,
                },
                {
                    title: 'Sub-Vertical',
                    column: 'ad',
                    columnIndexInGoogleSheets: 35,
                    priority: 0,
                    shapePath: titan_ads_1.titanAds.subVertical,
                    required: false,
                    internal: true,
                },
                // {
                //   title: 'Copy Description',
                //   column: 'ad',
                //   columnIndexInGoogleSheets: 19,
                //   priority,
                //   shapePath: titanAds.copyDescription,
                //   required: true,
                //   // internal: true,
                // },
                {
                    title: 'Brand Logo',
                    column: 'ad',
                    columnIndexInGoogleSheets: 36,
                    priority,
                    shapePath: titan_ads_1.titanAds.brandLogo,
                    required: true,
                    // internal: true,
                },
                {
                    title: 'Question',
                    column: 'ad',
                    columnIndexInGoogleSheets: 44,
                    priority: 0,
                    shapePath: titan_ads_1.titanAds.question,
                    required: false,
                    internal: true,
                },
                {
                    title: 'Answer',
                    column: 'ad',
                    columnIndexInGoogleSheets: 45,
                    priority: 0,
                    shapePath: titan_ads_1.titanAds.answer,
                    required: false,
                    internal: true,
                },
            ];
        }
        case 'rumble': {
            const priority = 0;
            return [
                {
                    required: false,
                    columnIndexInGoogleSheets: 0,
                    title: 'Ad ID',
                    priority,
                    column: 'ad',
                },
                {
                    title: 'Ad Name',
                    columnIndexInGoogleSheets: 1,
                    required: false,
                    priority,
                    column: 'ad',
                },
            ];
        }
        case 'taboola': {
            const priority = 0;
            return [
                {
                    title: 'Ad ID',
                    columnIndexInGoogleSheets: 0,
                    required: false,
                    priority,
                    column: 'ad',
                },
            ];
        }
    }
}
exports.getInputsByPlatform = getInputsByPlatform;
/**
 * Gets an input's unique key.  Multiple shapes can have the same
 * title - e.g. "Date Launched" - but the column, or shape, they belong
 * to is different.
 *
 * @example Title: "Date Launched", Column: "ad", key: "ad__Date Launched"
 * @param partial
 */
function getPartialKey(partial) {
    return `${partial.column}__${partial.title}`;
}
exports.getPartialKey = getPartialKey;
function getInputPartial(platform, title) {
    const inputs = getInputsByPlatform(platform);
    if (inputs) {
        return inputs.find((p) => p.title === title);
    }
    else {
        throw Error('No inputs found for platform: ' + platform + ' and title: ' + title);
    }
}
exports.getInputPartial = getInputPartial;
function getPartialKeyByTitle(platform, title) {
    const partial = getInputPartial(platform, title);
    return getPartialKey(partial);
}
exports.getPartialKeyByTitle = getPartialKeyByTitle;
function getPartialValue(partial, values, ad) {
    let value = values ? values[getPartialKey(partial)] : null;
    //added fallback method to get value from shape instead of input values
    if (!value && ad) {
        //TODO: currently this still uses shapePath, but this can be updated and removed/refactored, once we use accessor labels
        let nodeValue;
        const target = partial.column === 'adset'
            ? ad.adSet
            : partial.column === 'campaign'
                ? ad.adSet.campaign
                : ad;
        if (partial.shapePath instanceof models_1.NamedNode) {
            nodeValue = target.getOne(partial.shapePath);
        }
        else {
            nodeValue = target.namedNode.getOneFromPath(...partial.shapePath);
        }
        if (nodeValue instanceof models_1.Literal) {
            value = nodeValue.value;
        }
    }
    return value;
}
function populateTemplate(values, platform, template, limit = 0, ad) {
    const inputsToSkip = [];
    const result = Array.from({ length: template.length });
    const setResult = () => {
        // For each input placeholder in the template, find the corresponding value
        // and populate it accordingly
        template.forEach((inputTitle, i) => {
            if (typeof inputTitle === 'string' &&
                inputsToSkip.includes(inputTitle)) {
                return;
            }
            let value;
            if (typeof inputTitle === 'function' && ad) {
                value = inputTitle(ad);
            }
            else {
                const inputPartial = getInputPartial(platform, inputTitle);
                if (inputPartial) {
                    value = getPartialValue(inputPartial, values, ad);
                }
            }
            if (value) {
                result[i] = `${value}`;
            }
        });
        //filter out null/empty values
        return result.filter(Boolean);
    };
    setResult();
    if (limit) {
        let length = result.join(' - ').length;
        while (length > limit) {
            const last = result.pop();
            length = result.join(' - ').length;
        }
    }
    return result;
}
function generateEntityName(values, platform, template, limit = 0, ad) {
    const [prefixTemplate, suffixTemplate] = template;
    const prefix = prefixTemplate.join('-').replace('Test-', 'T-');
    const suffix = populateTemplate(values, platform, suffixTemplate, Math.max(limit - prefix.length, 0), ad).join(' - ');
    return [prefix, suffix].join(' - ');
}
function generateName(prefix, optionalProps, suffix, limit = 255) {
    const createName = (optionalProps) => {
        return (prefix +
            ' - ' +
            optionalProps.filter((prop) => prop && prop !== 'undefined').join(' - ') +
            ' - ' +
            suffix);
    };
    let name = createName(optionalProps);
    while (name.length > limit) {
        optionalProps.pop();
        name = createName(optionalProps);
    }
    return name;
}
exports.generateName = generateName;
/**
 * For generating ad names on the frontend with values from InputGroups
 * @param inputs
 * @param platform
 * @param campaign
 * @param adSet
 * @param limit
 * @param adId
 * @returns
 */
function generateAdName(inputs, platform, campaign, adSet, limit = 0, adId, ad) {
    return generateEntityName(inputs, platform, (0, types_1.AD_NAME_TEMPLATE)(campaign.identifier, adSet.identifier, adId), limit, ad);
}
exports.generateAdName = generateAdName;
function logError(error) {
    const timestamp = new Date().toLocaleTimeString();
    console.error(`[${timestamp}] :: ${error}`);
}
exports.logError = logError;
function getMatches(string, regex) {
    const matches = [];
    let match;
    while ((match = regex.exec(string))) {
        const viableMatches = match.filter((x, i) => typeof x === 'string' && i !== 0);
        matches.push(...viableMatches);
    }
    return matches;
}
exports.getMatches = getMatches;
function generateAdSetPrefix(deviceAndBrowser = 'Mobile & Desktop', placement = 'Feed') {
    const deviceAndBrowserPrefix = types_1.DeviceAndBrowserPrefixMap.get(deviceAndBrowser);
    const placementPrefix = types_1.PlacementPrefixMap.get(placement);
    switch (placementPrefix) {
        case 'E':
            return placementPrefix;
        default:
            return `${deviceAndBrowserPrefix}${placementPrefix}`;
    }
}
exports.generateAdSetPrefix = generateAdSetPrefix;
function wait(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
exports.wait = wait;
function getInputIndex(platform, title) {
    return getInputsByPlatform(platform).findIndex((partial) => partial.title === title);
}
exports.getInputIndex = getInputIndex;
function zeroPad(numberToPad, padBy = 3) {
    return `${numberToPad}`.padStart(padBy, '0');
}
exports.zeroPad = zeroPad;
function sum(arr) {
    return arr.reduce((tot, cur) => tot + cur, 0);
}
exports.sum = sum;
//# sourceMappingURL=utils.js.map